import React from 'react';
import Allocations from '../Allocations';
import CustomTabs from '../common/CustomTabs';
import PageHeader from '../common/PageHeader';
import MarketDetails from './MarketDetails';
import { IsSectionVisible } from '../../utils/helper';
import { SECTIONS } from '../../constants/appConstants';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
class MarketInfo extends React.PureComponent {
  constructor (props) {
    super(props);
    this.state = { MarketDetails: undefined, PropertyData: undefined, configuration: undefined };
  }

  componentDidMount () {
  }

  render () {
    const Tabs = [
      {
        name: 'View Market',
        id: 1,
        childComponent: (
            <MarketDetails
                selectedMarketID={this.props.selectedMarketID}
                onBackClick={this.props.onBackClick} />)
      }
    ];
    if (IsSectionVisible(SECTIONS.ALLOCATIONS, SECTIONS.MARKET_ALLOCATION)) {
      Tabs.push(
        {
          name: 'Market Allocations',
          id: 2,
          childComponent: <Allocations
                  marketId={this.props.selectedMarketID}
                  allocationType={[{ allocationType: 'Market' }]}
                  renderAsChild={true}
              ></Allocations>
        });
    }
    return (
      <>
        <div className="col-sm-12 col-lg-12">
          <PageHeader title="Market Details" actionsConfig={
            [
              {
                icon: <ArrowBackIcon size="small" className="back-button" />,
                onClick: this.props.onBackClick ,
                title:"Back to Market"
              }
            ]
          }></PageHeader>
        </div>

        <div className="row Row_flex bottom-lg">

            <CustomTabs tabsList={Tabs} currentSelectedTab={1} />

          {/* <div className="col-sm-12 col-lg-1 bottom-lg">
            <Tooltip title="Back to Market">
              <ArrowBackIcon size="small" className="back-button" onClick={this.props.onBackClick} />
            </Tooltip>
          </div> */}
        </div>
       </>
    );
  }
}

export default MarketInfo;
